import React from 'react';

import Tooltip from 'component/Layout/Tooltip';
import { TooltipPosition } from 'component/Layout/Tooltip/types';

import classNames from 'classnames';

import { ConditionalWrapper } from 'utility/Check/ConditionalWrapper';

import { BadgeProps, BadgeType } from './types';

import styles from './Badge.module.scss';

const Badge: React.FC<React.PropsWithChildren<BadgeProps>> = ({
    children,
    type = BadgeType.BOX,
    customClass,
    tooltipContent,
    tooltipConfig,
}) => {
    const styleClasses = classNames(styles.Badge, styles[type], customClass);
    return (
        <ConditionalWrapper
            condition={!!tooltipContent}
            wrapper={(children: React.ReactElement) => (
                <Tooltip
                    content={tooltipContent}
                    placement={
                        tooltipConfig?.placement ?? TooltipPosition.Bottom
                    }
                    overlayClassName={tooltipConfig?.overlayClassName}
                    align={tooltipConfig?.align}
                >
                    {children}
                </Tooltip>
            )}
        >
            <span className={styleClasses}>{children}</span>
        </ConditionalWrapper>
    );
};

export default Badge;

type BadgeWithIconProps = BadgeProps & {
    // Preferrably a type SvgIconName, but thats a story for another day
    SvgIcon: React.FC<React.SVGProps<SVGSVGElement>>;
};
export const BadgeWithIcon = (props: BadgeWithIconProps) => {
    return (
        <Badge
            {...props}
            customClass={classNames(props.customClass, styles.BadgeWithIcon)}
        >
            <props.SvgIcon /> {props.children}
        </Badge>
    );
};
